import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPrivateConversationsAction } from '../../../redux/actions/chatActions'
import SingleConversation from './SingleConversation'
import { socket } from "../../../utils/socket.js"

const ConversationsList = ({ keyword, conversationID, setConversationID, setNewUserID, setNewUserData }) => {


    const dispatch = useDispatch()

    const { loading, conversations, totalConversations } = useSelector(state => state.conversations)
    const { message: msg } = useSelector(state => state.sendPrivateMessage)
    const [onlineUsers, setOnlineUsers] = useState([])

    useEffect(() => {
        socket.emit("get_online_users");

        socket.on("online_users", (data) => {
            setOnlineUsers(data);
        });

        return () => {
            socket.off("online_users");
        };
    }, []);



    const [perPage, setPerPage] = useState(100)



    useEffect(() => {

        const query = {}


        if (keyword) query.search = keyword
        query.perPage = perPage

        dispatch(getPrivateConversationsAction(query))



    }, [dispatch, keyword, perPage, msg])
    return (
        <Fragment>
            <div className="mt-[0.5vmax] h-[55vh] overflow-y-auto my-scroll pr-[0.5vmax]">
                {conversations?.length > 0 ? (
                    conversations.map((conversation) => (
                        <SingleConversation
                            key={conversation?.conversation_id}
                            conversation_id={conversation?.conversation_id}
                            user={conversation?.other_user}
                            last_message={conversation?.last_message}
                            last_message_at={conversation?.last_message_at}
                            is_last_message_seen={conversation?.is_last_message_seen}
                            conversationID={conversationID}
                            setConversationID={setConversationID}
                            setNewUserID={setNewUserID}
                            setNewUserData={setNewUserData}
                            isOnline={onlineUsers.includes(String(conversation?.other_user?.id))}
                        />
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center h-[30vh] text-gray-400 gap-[0.5vmax]">
                        <i className="fa-regular fa-folder-open text-[2vmax]"></i>
                        <p className="text-[1vmax] font-medium">No Messages Found</p>
                    </div>
                )}
                
                {!loading && totalConversations > perPage && (
                    <div className="flex justify-center mt-[1vmax]">
                        <button 
                            className="text-[0.85vmax] font-bold text-indigo-600 hover:text-indigo-700"
                            onClick={() => { setPerPage(prev => prev + 100) }}
                            disabled={totalConversations <= perPage}
                        >
                            {totalConversations <= perPage ? 'No More Users to show' : 'Load More'}
                        </button>
                    </div>
                )}
                
                {loading && conversations?.length === 0 && (
                    <div className="w-[2vmax] h-[2vmax] border-4 border-gray-200 border-t-indigo-600 rounded-full animate-spin mx-auto my-[2vmax]" />
                )}
            </div>
        </Fragment>
    )
}

export default ConversationsList
